<template>
    <div id="printing-detail">
        <div id="printing-detail-line">
            <table border="0" cellspacing="0" cellpadding="0" style="width: 100%">
                <tr>
                    <td class="table-header">日期</td>
                    <td class="table-header">印花内容</td>
                    <td class="table-header">印花</td>
                    <td class="table-header">累计印花</td>
                </tr>

                <tr v-for="(item, index) in printingDetail" :key="index">
                    <td class="table-content">{{item.time}}</td>
                    <td class="table-content" style="text-align: left; width: 150px">{{item.content}}</td>
                    <td class="table-content">{{item.addstamp}}</td>
                    <td class="table-content">{{item.stampQuantityChange}}</td>
                </tr>

            </table>
        </div>
    </div>
</template>

<script>
    import {stampUpdateLog} from "../api/Stamp";
    import {formatDate} from "../unitls";

    export default {
        name: "PrintingDetail",

        data() {
            return {
                printingDetail:[]
            }
        },

        mounted() {
            this.getStampExchangeLogList()
        },

        methods: {
            getStampExchangeLogList(){
                stampUpdateLog(0,-1).then(response => {

                    if (this.$API_CODE.OK === response.code) {
                        this.printingDetail = [];
                        response.data.list.forEach((item) => {
                            this.printingDetail.push({
                                time: formatDate(item.addtime, 'yyyy-MM-dd'),
                                content: this.stampConsumeType(item.stampType, item.remark),
                                addstamp: item.addstamp,
                                stampQuantityChange: item.stampQuantityChange
                            })
                        })
                    }
                })
            },


            stampConsumeType(type, remark) {
                let content;

                if (type === 'EXCHANGE_REDUCE') {
                    content = remark;
                } else if (type === this.$EXCHANGE_REDUCE.BUY_ADD) {
                    content = '购买增加' + remark;
                } else if (type === this.$EXCHANGE_REDUCE.SCORE_TRANSFER_STAMP) {
                    content = '积分转印花' + remark;
                } else if (type === this.$EXCHANGE_REDUCE.EXCHANGE_CANCEL) {
                    content = '取消兑换返还' + remark;
                } else if (type === this.$EXCHANGE_REDUCE.ADMIN_ADD) {
                    content = '后台增加' + remark;
                } else if (type === this.$EXCHANGE_REDUCE.ADMIN_REDUCE) {
                    content = '后台减少' + remark;
                } else {
                    content = '参与兑换' + remark;
                }

                return content;
            }
        }
    }
</script>

<style scoped lang="scss">
    #printing-detail {
        background-color: #FFFFFF;

        #printing-detail-line {
            border: 1px solid #ed3f14;
            margin-top: 10px;
            border-radius: 10px;
            padding: 10px;

            .table-header {
                border-bottom: 1px solid #000000;
                padding-bottom: 10px;
                text-align: center;
            }

            .table-content {
                border-bottom: 1px dashed #dddddd;
                padding: 10px 5px 10px 5px;
                font-size: 14px;
            }
        }
    }
</style>